import { useGetCompanies } from 'hq/hooks/queryHooks/companies/use-get-companies';
import { RenderUnsettledUI } from 'shared/components';
import { FormProvider, useForm } from 'react-hook-form';
import { HQProjectFormTypeCreate } from 'shared/components/project-forms/types/project-form.types';
import { ProjectCreateFormPage } from './project-create-form-page';

export const ProjectCreateDataProvider = () => {
  const formMethods = useForm<HQProjectFormTypeCreate>({ defaultValues: { location: null } });

  const companiesQuery = useGetCompanies();

  if (companiesQuery.status !== 'success') {
    return <RenderUnsettledUI data={companiesQuery} />;
  }

  return (
    <FormProvider {...formMethods}>
      <ProjectCreateFormPage
        companies={companiesQuery.data}
        successMessage={`Project aangemaakt`}
        pageTitle={`Maak nieuw project aan`}
      />
    </FormProvider>
  );
};
